import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { HStack as i } from "@chakra-ui/react";
import { SgiLogo as m } from "../../../branding/SgiLogo/SgiLogo.mjs";
import { SgiCanadaLogo as t } from "../../../branding/SgiCanadaLogo/SgiCanadaLogo.mjs";
const e = () => /* @__PURE__ */ r(i, { spacing: { base: 2, md: 3 }, children: [
  /* @__PURE__ */ o(m, { width: { base: "82.1px", md: "100px" } }),
  /* @__PURE__ */ o(t, { width: { base: "57.9px", md: "70px" } })
] });
export {
  e as DefaultBranding
};
